import React from 'react'

 const NotFound = () => {
    return (
        <div>
            <h1>Not Found</h1>
            <p className='lead'> The Page You are looking for doesnot exists</p>
        </div>
    )
}

export default NotFound